import AppConfig from "../../AppConfig";
import { fetchWithAuthPost } from "../../Flux/FetchWithAuth";
import BookFiltersStore from "../../Flux/Stores/BookFiltersStore";
import { v4 as uuid } from "uuid";

const { ApiBasePath } = AppConfig.getBookApiBasePath();

export const loadTaxonomyData = async (abortController) => {
	const contextValues = BookFiltersStore.getContextValues();
	const url = `${ApiBasePath}/plook/TaxonomyHistoryLog/GetTaxonomyHistoryLog`;
	const response = await fetchWithAuthPost(url, JSON.stringify(contextValues), { abortController });
	return (
		response
			?.sort((a, b) => new Date(b.LastUpdated) - new Date(a.LastUpdated))
			?.map((data) => ({
				...data,
				id: uuid(),
				createdByUserName: `${data.CreatedBy_FirstName} ${data.CreatedBy_LastName}`,
				updatedByUserName: `${data.UpdatedBy_FirstName} ${data.UpdatedBy_LastName}`,
				formattedCreatedDate: new Date(data.CreatedDate)?.toLocaleDateString?.(),
				formattedLastModifiedDate: new Date(data.LastUpdated)?.toLocaleDateString?.(),
				MasterCountryName: data.MasterCountryName || "",
				taxonomyOrigin: data.TaxonomyOrigin || ""
			})) || []
	);
};

export const loadCampaignsData = async (abortController) => {
	const contextValues = BookFiltersStore.getContextValues();
	const url = `${ApiBasePath}/plook/CampaignHistoryLog/GetCampaignHistoryLog`;
	const response = await fetchWithAuthPost(url, JSON.stringify(contextValues), { abortController });
	return (
		response
			?.sort((a, b) => new Date(b.LastUpdated) - new Date(a.LastUpdated))
			?.map((data) => ({
				...data,
				id: uuid(),
				createdByUserName: `${data.CreatedBy_FirstName} ${data.CreatedBy_LastName}`,
				updatedByUserName: `${data.UpdatedBy_FirstName} ${data.UpdatedBy_LastName}`,
				formattedCreatedDate: new Date(data.CreatedDate)?.toLocaleDateString?.(),
				formattedLastModifiedDate: new Date(data.LastUpdated)?.toLocaleDateString?.(),
				TaxonomyString: data.CampaignName,
				MasterCountryName: data.MasterCountryName || ""
			})) || []
	);
};
